const autoNgTemplateLoaderTemplate1 = require('./add-sales-rep.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.addSalesRep', [])
        .config(addSalesRepConfig);

    addSalesRepConfig.$inject = ['$routeProvider'];

    function addSalesRepConfig($routeProvider) {
        $routeProvider
            .when('/add-sales-rep', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'AddSalesRepController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Sales Representatives', icon: NAVIGATION_ICON.MONITORING }
                    ]
                }
            })
    }
})();
